// extracted by mini-css-extract-plugin
export default {"learn_more":"GvIG0I-VZMp3dNwjHwHji","animated_arrow_right":"_3kMeLdPWpKxKzDfu3-ehGd","arrow-animation":"_2fx2bc_G4swvARipmr2z4a"};